import { Component, Input, OnInit } from "@angular/core";
import { DashboardMultiStationService } from "../dashboard-multistation.service";

@Component({
	selector: "caass-ms-todays-snapshot",
	templateUrl: "./ms-todays-snapshot.component.html",
	styleUrls: ["./ms-todays-snapshot.component.css"],
})
export class MsTodaysSnapshotComponent implements OnInit {
	constructor(private visitorService: DashboardMultiStationService) {}

	ngOnInit(): void {
		this.loadData();
	}

	ngOnChanges() {
		this.loadData();
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	@Input() FacilityID: number = -1;

	SignedInCount: number = 0;
	SignedOutCount: number = 0;
	DeniedCount: number = 0;
	SystemSignedOutCount: number = 0;
	DistrictPotentialOffenderHits: number = 0;
	InBuildingCount: number = 0;
	StudentScans: number = 0;
	StaffScans: number = 0;

	loading: boolean = false;

	OptionID: number = 0;
	Title: string = "Facility";

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////

	loadData() {
		this.ClearData();

		if (this.FacilityID == undefined || this.FacilityID < 0) {
			return;
		}

		this.loading = true;

		var result = this.visitorService.VisitorSnapshotStatsSelect(this.OptionID == 0 ? this.FacilityID : -1);
		result.subscribe(
			(response: any) => {
				this.SignedInCount = response.SignedInCount == undefined ? 0 : response.SignedInCount;
				this.SignedOutCount = response.SignedOutCount == undefined ? 0 : response.SignedOutCount;
				this.DeniedCount = response.DeniedCount == undefined ? 0 : response.DeniedCount;
				this.SystemSignedOutCount = response.SystemSignedOutCount == undefined ? 0 : response.SystemSignedOutCount;
				this.DistrictPotentialOffenderHits = response.DistrictPotentialOffenderHits == undefined ? 0 : response.DistrictPotentialOffenderHits;
				this.InBuildingCount = response.InBuildingCount == undefined ? 0 : response.InBuildingCount;
				this.StudentScans = response.StudentScans == undefined ? 0 : response.StudentScans;
				this.StaffScans = response.StaffScans == undefined ? 0 : response.StaffScans;

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////

	SelectOption(opt) {
		this.OptionID = opt;

		if (this.OptionID == 0) {
			this.Title = "Facility";
		} else if (this.OptionID == 1) {
			this.Title = "District";
		}

		this.loadData();
	}
	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////

	ClearData() {
		this.SignedInCount = 0;
		this.SignedOutCount = 0;
		this.DeniedCount = 0;
		this.SystemSignedOutCount = 0;
		this.DistrictPotentialOffenderHits = 0;
		this.InBuildingCount = 0;
		this.StudentScans = 0;
		this.StaffScans = 0;
	}

	//////////////////////////////////////////////////////////
}
